import React from "react";
import "./ServicesContent.css";

function ServicesContent() {

  return (
    <div className="services_info ">
      <div className="services_info_title container">
        <h1>
          Logistics <span>Service</span>
        </h1>
        <p>
          We deliver innovative logistics solutions across road, air, and sea —
          bringing your cargo safely, fast and globally.
        </p>
      </div>
      <div className="overall_services container" id="all_services">
        <div className="statement_container">
          <div className="statement_container_title">
            <h3>Capability Statement</h3>
            <hr />
          </div>

          <div className="statement_texts">
            <p className="statement_texts_p1">
              <strong>Artel Logistics Inc</strong> is a trucking company
              established in February 2020. Within just five years, we have
              grown to operate
              <strong>140 power units</strong> and
              <strong>160 dry van trailers</strong>. Our mission is to deliver
              excellence in transportation services across the United States.
            </p>
            <p className="statement_texts_p2">
              Thanks to our dedicated team, we’ve built strong partnerships with
              leading logistics providers such as
              <strong>
                FedEx, UPS, C.H. Robinson, J.B. Hunt, Coyote, Swift, Schneider,
                ITS, Freedom Trans
              </strong>
              , and more.
            </p>
            <p className="statement_texts_p3">
              We currently run multiple dedicated routes with U.S. Mail,
              providing reliable and professional interstate freight
              transportation services nationwide.
            </p>
          </div>
          <div className="statement_roads">
            <div className="road1">
              <h4><span>Core</span> Competencies</h4>
              <p>PROVIDING SERVICES 24/7 WITH OUR ON-BOARD TEAM;</p>
              <p>LATEST TMS SYSTEMS TO TRACK ACCURACY AND SAFETY OPERATIONS;</p>
              <p>FULLY MAINTAINED FLEET WITH NEWEST EQUIPMENT;</p>
              <p>24/7 MONITORING AVAILABILITY FOR FEMA NEEDS.</p>
            </div>
            <div className="road2">
              <div></div>
              <div className="performances_data">
                  <h4>Past <span>Performance</span></h4>
                <div className="performance_data_cards">
                  <div className="first_4">
                    <p>Freedom – $21,951,385.33</p>
                    <p>Amazon – $2,643,028.00</p>
                    <p>ITS – $4,740,279.18</p>
                    <p>J.B. Hunt – $1,288,380.38</p>
                  </div>
                  <div className="second_4">
                    <p>Coyote – $351,547.65</p>
                    <p>TQL – $195,492.48</p>
                    <p>Veltri – $2,558,858.96</p>
                    <p>Forward Air – $242,850.32</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="road3">
              <h4><span>Company</span> Data</h4>
              <p>
                <strong>DUNS:</strong> 08-981-2264
              </p>
              <p>
                <strong>CAGE Code:</strong> 9HUL0
              </p>
              <p>
                <strong>NAICS:</strong> 484121, 484210, 484220, 484230, 492110,
                532490
              </p>
              <p>
                <strong>PSC:</strong> V112, V129, V122, V119, V301, W023
              </p>
              <p>
                <strong>Fleet:</strong> 140 Power Units, 160 Trailers
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg_swimmers_services">
        <svg className="services_swimmer1 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
        <svg className="services_swimmer2 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
        <svg className="services_swimmer3 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
        <svg className="services_swimmer4 " viewBox="0 0 100 100" fill="none"><path d="M10,30 C20,5 80,5 90,30 C100,55 80,95 50,80 C20,65 0,55 10,30 Z" stroke="#60A5FA" strokeWidth="2" fill="none"></path></svg>
      </div>
    </div>
  );
}

export default ServicesContent;
